import { Typography } from '@/app/common';
import { CustomPortableText } from '@workspace/ui/PortableText';
import { TimelineItem as ITimelineItem } from '../milestone.types';
import { cn } from '@workspace/lib';

interface TimelineItemProps {
  isLast: boolean;
  item: ITimelineItem;
  isFirst: boolean;
}
export function TimelineItem({ item, isLast, isFirst }: TimelineItemProps) {
  return (
    <div
      key={item._key}
      className={cn(
        'flex flex-col gap-lg relative',
        'md:flex-1 md:flex-start md:px-0 md:mb-0 md:ml-0 md:min-w-38.75 w-full',
        'px-lg', // only applies on mobile
      )}
    >
      {/* Arrow */}
      {!isLast && (
        <div className="absolute left-0 top-[5px] z-0 w-0.5 h-[calc(100%+(var(--spacing-xl)))] md:w-full md:h-0.5 md:top-0 bg-secondary-400 -translate-x-1/2 md:translate-x-0"></div>
      )}
      {!isFirst && (
        <div
          className={cn(
            'md:flex absolute left-0 md:right-full md:left-auto top-[5px] md:top-0 z-0 w-0.5 h-[calc(100%+(var(--spacing-xl)))] md:w-full md:h-0.5 bg-secondary-400 -translate-x-1/2 md:translate-x-0',
            isLast && 'hidden',
          )}
        ></div>
      )}

      {/* Dot */}
      <span
        className={cn(
          'w-5 h-5 rounded-full md:-mt-xs bg-primary z-10',
          'absolute left-0 top-[5px] md:top-0 -translate-x-1/2 md:translate-0 md:static',
        )}
      />

      {/* Content */}
      <div className="flex flex-col gap-xs items-start max-w-full md:max-w-61.75 relative z-10">
        <Typography
          variant="h5"
          className={cn('!text-primary', '!text-lg md:text-2xl! md:max-w-56.5 !font-bold md:mb-0')}
        >
          {item.yearDecade}
        </Typography>
        <CustomPortableText
          className={`md:*:max-w-44.25 *:wrap-break-word md:text-sm *:text-inherit!`}
          value={item.description}
        />
      </div>
    </div>
  );
}
